import { FC, useMemo } from 'react'

import { useAvailableApps } from 'modules/app-registry/hooks/useAvailableApps'

import { FeatureCardData } from '../../DiscoverAppsModal.constant'
import { FeatureCard } from '../FeatureCard'

interface CardRendererProps {
  card: FeatureCardData
  title: string
  featureName: string
  heading: string
  description: string
  onTourClick: () => void
  onTellMeMoreClick: () => void
  wrapperClassName?: string
}

export const CardRenderer: FC<CardRendererProps> = ({
  card,
  title,
  featureName,
  heading,
  description,
  onTourClick,
  onTellMeMoreClick,
  wrapperClassName
}) => {
  const { apps } = useAvailableApps()
  const cardElement = useMemo(
    () => (
      <FeatureCard
        title={title}
        featureName={featureName}
        heading={heading}
        description={description}
        iconPath={apps[card.appId].icon}
        videoPath={card.videoPath}
        onTourClick={onTourClick}
        onTellMeMoreClick={onTellMeMoreClick}
      />
    ),
    [
      title,
      featureName,
      heading,
      description,
      apps,
      card.appId,
      card.videoPath,
      onTourClick,
      onTellMeMoreClick
    ]
  )

  if (wrapperClassName) {
    return <div className={wrapperClassName}>{cardElement}</div>
  }

  return cardElement
}
